import { IMAGES } from "../../config/landingConfig";
import { scrollToId } from "../../lib/scroll";
import { Reveal } from "./Reveal";
import { PhotoSlot } from "./PhotoSlot";

export const FinalCta = () => {
  const go = (e) => {
    e.preventDefault();
    scrollToId("#pakiety");
  };

  return (
    <section data-testid="final-cta-section" className="border-y-4 border-ink bg-magenta">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 py-20 sm:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:py-28">
        <div>
          <Reveal>
            <h2 className="font-display text-3xl uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
              Twórz gry, w które uczniowie{" "}
              <span className="marker-cyan text-ink">chcą grać</span> i dzięki
              którym naprawdę się uczą
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/90 sm:text-lg">
              Wykorzystaj AI do projektowania aktywności dopasowanych do Twoich
              uczniów, celów i sposobu pracy. Zbuduj własną bibliotekę mechanik,
              promptów i gier, z której będziesz korzystać przez kolejne lata.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <a
              href="#pakiety"
              data-testid="final-cta-button"
              onClick={(e) => {
                window.fbq?.("trackCustom", "ClickCTA", { location: "final-cta" });
                go(e);
              }}
              className="hover-lift mt-8 inline-block rounded-full border-2 border-ink bg-cyan px-8 py-4 text-base font-extrabold text-ink shadow-hard"
            >
              Wybieram swój pakiet
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.12} className="relative mx-auto w-full max-w-sm lg:max-w-none">
          <div className="float-soft absolute -right-4 -top-5 z-10 h-12 w-12 rotate-12 rounded-2xl border-2 border-ink bg-cyan shadow-hard-sm" aria-hidden="true" />
          <PhotoSlot
            src={IMAGES.cta}
            alt="Anna Popławska zaprasza do kursu AI Speaking Games"
            slotLabel="końcowe CTA"
            className="aspect-square w-full rotate-2 rounded-[2rem] border-4 border-ink bg-white shadow-hard-lg"
          />
        </Reveal>
      </div>
    </section>
  );
};
